/** What the tour put on the page, so its cleanup removes only that and never the person's own content. */
const DEMO_MESSAGE_ID_PREFIX = 'tutorial-demo-';

export const demoMessageId = (index: number) => `${DEMO_MESSAGE_ID_PREFIX}${index}`;

export const isDemoMessageId = (id: string) => id.startsWith(DEMO_MESSAGE_ID_PREFIX);

/** The sample lines as one dictation text, the way the page shows them. */
export const appendDemoText = (text: string, line: string) => (text ? `${text}\n${line}` : line);

/** The text with the sample taken out; anything the person added around it is kept as it was. */
export const withoutDemoText = (text: string, demoText: string) => {
  const start = demoText ? text.indexOf(demoText) : -1;
  if (start < 0) return text;
  // Only the line break that joined the sample to the person's text goes with it.
  const before = text.slice(0, start).replace(/\n$/, '');
  const after = text.slice(start + demoText.length).replace(/^\n/, '');
  return before && after ? `${before}\n${after}` : before || after;
};
